import { programCategoriesApi } from '@/admin/api/program-categories';
import { queryOptions } from '@tanstack/react-query';

export const programCategoriesQuery = () =>
	queryOptions({
		queryKey: ['program-categories'] as const,
		queryFn: () => programCategoriesApi.list({ per_page: 100 }),
		staleTime: 5 * 60_000,
		gcTime: 10 * 60_000,
		refetchOnWindowFocus: false,
	});
